// Display-only components
import SectionHeader from './SectionHeader.vue';
import Description from './Description.vue';
import NoteHelp from './NoteHelp.vue';
import Image from './Image.vue';
import ClinicBranding from './ClinicBranding.vue';

// Basic input components
import ShortResponse from './ShortResponse.vue';
import LongResponse from './LongResponse.vue';
import Email from './Email.vue';
import Phone from './Phone.vue';

// Date/Time components
import Date from './Date.vue';
import DateTime from './DateTime.vue';
import Time from './Time.vue';

// Specialized input components
import Numeric from './Numeric.vue';
import Signer from './Signer.vue';

// Selection components
import Checkbox from './Checkbox.vue';
import YesNo from './YesNo.vue';
import SingleSelection from './SingleSelection.vue';
import MultiSelection from './MultiSelection.vue';
import Dropdown from './Dropdown.vue';

// Rating component
import Rating from './Rating.vue';

// Wrapper component
import FormFieldWrapper from './FormFieldWrapper.vue';

// Component mapping by element type (must match kebab-case keys from formElementFactory)
export const formComponentMap = {
  'section-header': SectionHeader,
  'description': Description,
  'note-help': NoteHelp,
  'image': Image,
  'clinic-branding': ClinicBranding,
  'short-response': ShortResponse,
  'long-response': LongResponse,
  'email': Email,
  'phone': Phone,
  'date': Date,
  'datetime': DateTime,
  'time': Time,
  'numeric': Numeric,
  'signer': Signer,
  'checkbox': Checkbox,
  'yes-no': YesNo,
  'single-selection': SingleSelection,
  'multi-selection': MultiSelection,
  'dropdown': Dropdown,
  'rating': Rating
};

// Named exports
export {
  // Display-only
  SectionHeader,
  Description,
  NoteHelp,
  Image,
  ClinicBranding,
  
  // Basic input
  ShortResponse,
  LongResponse,
  Email,
  Phone,
  
  // Date/Time
  Date,
  DateTime,
  Time,
  
  // Specialized input
  Numeric,
  Signer,
  
  // Selection
  Checkbox,
  YesNo,
  SingleSelection,
  MultiSelection,
  Dropdown,
  
  // Rating
  Rating,
  
  // Wrapper
  FormFieldWrapper
};

// Default export
export default formComponentMap;
